const getters = {
    reservations: state => state.reservations,
};

export default getters;